import {
  DELETE_SHIPPING_PROVIDER,
  INSERT_SHIPPING_PROVIDER
} from 'graphql/mutations/integrations';
import * as Yup from 'yup';

const skydropData = {
  key: 'SKYDROP',
  createMutation: INSERT_SHIPPING_PROVIDER,
  deleteMutation: DELETE_SHIPPING_PROVIDER,
  noDisplayFields: [
    { name: 'clientId', path: 'clientId' },
    { name: 'providerId', path: 'id' }
  ],
  getMixedTypes: (params) => {
    return {
      service: () => {
        const notAvailableItems = params?.integrationsData?.map(
          (item) => item.service
        );

        return ['NACIONAL', 'PROGRAMADO', 'EXPRESS'].filter(
          (item) => !notAvailableItems?.includes(item)
        );
      }
    };
  },
  fields: [
    {
      title: 'Alias',
      label: 'Ej. Primera integración',
      keyName: 'alias',
      type: '',
      initialValue: '',
      helperText: 'Introduce un nombre para identificar esta integración',
      validationSchema: Yup.string().required('Ingresa el campo Alias')
    },
    {
      title: 'Servicio',
      label: 'Ej. PROGRAMADO',
      keyName: 'service',
      type: [],
      initialValue: '',
      helperText: 'Introduce el tipo de servicio',
      validationSchema: Yup.string().required('Ingresa el campo SERVICIO')
    },
    {
      label: 'Metadata',
      keyName: 'metadata',
      type: {},
      fields: [
        {
          title: 'SKYDROP TOKEN',
          label: 'Ej: skydrop_token_example',
          keyName: 'skydropToken',
          type: '',
          initialValue: '',
          helperText: 'Introduce tu SKYDROP TOKEN',
          validationSchema: Yup.string().required('Ingresa el campo API KEY')
        },
        {
          title: 'WHITELIST',
          label: 'Ej: ESTAFETA,FEDEX,REDPACK',
          keyName: 'whitelist',
          type: '',
          initialValue: '',
          helperText:
            'Introduce la WHITELIST, a modo de una lista separada por comas como se muestra en el ejemplo',
          validationSchema: Yup.string().required('Ingresa el campo WHITELIST')
        }
      ]
    }
  ]
};

export default skydropData;
